import Colaborators from '@/components/colaborators/Colaborators'
import ColaboratorDetail from '@/components/colaborators/ColaboratorDetail'
import ColaboratorCreate from '@/components/colaborators/ColaboratorCreate'
import ColaboratorUpdate from '@/components/colaborators/ColaboratorUpdate'
import AccountCreate from '@/components/colaborators/accounts/AccountCreate'
import AccountUpdate from '@/components/colaborators/accounts/AccountUpdate'

const colaboratorsRoutes = [
  { path: '/colaborators', name: 'colaborators', component: Colaborators },
  { path: '/colaborator/create', name: 'colaborator_create', component: ColaboratorCreate },
  { path: '/colaborator/update/:id', name: 'colaborator_update', component: ColaboratorUpdate },
  { path: '/colaborator/:id', name: 'colaborator', component: ColaboratorDetail },
  { path: '/account/create/:id', name: 'account_create', component: AccountCreate },
  { path: '/account/update/:id', name: 'account_update', component: AccountUpdate }
]

export default colaboratorsRoutes



// WEBPACK FOOTER //
// ./src/router/colaborators_routes.js